<div class="wrapper">
    <div class="content">
        <app-header-user *ngIf="showHeaderFooter" class="header"></app-header-user>
        <router-outlet></router-outlet>
    </div>
    <app-footer-user *ngIf="showHeaderFooter"></app-footer-user>
</div>